const jsonHeaders = {
  Accept: "application/json",
  "Content-type": "application/json",
};

const apiHost = `https://api-stage-rel.katomaran.co.in`

export default function ({ uri, method = "GET", body }) {
  return fetch(apiHost + uri, {
    method,
    body,
    headers: jsonHeaders,
  }).then(async (response) => {
    if (response.ok) {
      try {
        return response.json();
      } catch (err) {
        return true;
      }
    }
    const errorMessage = [response.status, await response.json()];
    throw errorMessage;
  });
}
